// Shared light/dark-aware color palette for the Administrators page surfaces,
// keeping text and icons legible on the light dashboard instead of white-on-white.
import { useColorModeValue } from "@chakra-ui/react";

/**
 * Returns theme-aware Chakra color tokens used across the admin profile and
 * revenue cards so labels, values, and icons stay readable in both modes.
 * @returns {Object} Named color tokens (text, surfaces, borders, accent).
 */
export function useAdminPalette() {
    return {
        textPrimary: useColorModeValue("secondaryGray.900", "white"),
        textSecondary: useColorModeValue("secondaryGray.700", "secondaryGray.400"),
        textMuted: useColorModeValue("secondaryGray.600", "secondaryGray.500"),
        border: useColorModeValue("secondaryGray.200", "whiteAlpha.200"),
        rowBg: useColorModeValue("secondaryGray.300", "whiteAlpha.100"),
        rowBgHover: useColorModeValue("secondaryGray.400", "whiteAlpha.200"),
        accent: useColorModeValue("brand.500", "brand.400"),
        accentTint: useColorModeValue("brand.100", "whiteAlpha.200"),
    };
}
